var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[(_vm.content === true)?_c('div',[_c('i',{staticClass:"fa fa-check"})]):_c('i')])}
var staticRenderFns = []

export { render, staticRenderFns }